import { useEffect, useState } from "react";
import { api, formatApiErrorDetail } from "../lib/api";
import { useSettings } from "../context/SettingsContext";
import { Input } from "../components/ui/input";
import { Textarea } from "../components/ui/textarea";
import { Button } from "../components/ui/button";
import { toast } from "../components/ui/sonner";

export default function Contact() {
  const { settings } = useSettings();
  const [form, setForm] = useState({ name: "", email: "", subject: "", message: "" });
  const [sending, setSending] = useState(false);
  const [sent, setSent] = useState(false);
  const [blocks, setBlocks] = useState([]);

  useEffect(() => {
    api.get("/content/contact").then(({ data }) => setBlocks(data)).catch(() => {});
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSending(true);
    try {
      await api.post("/contact", form);
      setSent(true);
      toast.success("Message sent");
    } catch (err) {
      toast.error(formatApiErrorDetail(err.response?.data?.detail));
    } finally {
      setSending(false);
    }
  };

  return (
    <div data-testid="contact-page">
      <section className="bg-midnight-black py-16 text-center">
        <p className="text-stranger-orange text-xs font-bold tracking-[0.25em] uppercase mb-3">Get in Touch</p>
        <h1 className="text-clean-white font-extrabold uppercase tracking-tight text-3xl sm:text-5xl">Contact Us</h1>
        {blocks.map((b) => (
          <p key={b.id} className="text-clean-white/70 font-medium text-sm max-w-xl mx-auto mt-5" data-testid={`contact-block-${b.id}`}>
            {b.body}
          </p>
        ))}
        {settings.support_email && (
          <p className="text-clean-white/60 font-medium text-sm mt-4" data-testid="contact-support-email">
            Or email us directly at{" "}
            <a href={`mailto:${settings.support_email}`} className="text-stranger-orange hover:underline">
              {settings.support_email}
            </a>
          </p>
        )}
      </section>
      <section className="bg-clean-white py-16">
        <div className="max-w-lg mx-auto px-5 sm:px-8">
          {sent ? (
            <p className="text-center font-medium text-midnight-black/70" data-testid="contact-sent-message">
              Thanks for reaching out. We'll get back to you soon.
            </p>
          ) : (
            <form onSubmit={handleSubmit} className="space-y-4" data-testid="contact-form">
              <Input data-testid="contact-name-input" placeholder="Your name" required value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} />
              <Input data-testid="contact-email-input" type="email" placeholder="Your email" required value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} />
              <Input data-testid="contact-subject-input" placeholder="Subject" required value={form.subject} onChange={(e) => setForm({ ...form, subject: e.target.value })} />
              <Textarea data-testid="contact-message-input" placeholder="Your message" required value={form.message} onChange={(e) => setForm({ ...form, message: e.target.value })} />
              <Button type="submit" data-testid="contact-submit-button" disabled={sending} className="w-full bg-stranger-orange hover:bg-orange-600 text-clean-white font-bold rounded-full py-6">
                {sending ? "Sending..." : "SEND MESSAGE"}
              </Button>
            </form>
          )}
        </div>
      </section>
    </div>
  );
}
